import { render, staticRenderFns } from "./alignmentView.vue?vue&type=template&id=081c0b51&scoped=true&"
import script from "./alignmentView.vue?vue&type=script&lang=js&"
export * from "./alignmentView.vue?vue&type=script&lang=js&"
import style0 from "./alignmentView.vue?vue&type=style&index=0&id=081c0b51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c0b51",
  null
  
)

export default component.exports